import { createSelector } from 'reselect';
import { getFolders } from '../selector';
import { FolderView } from './view/FolderView';

export const myFoldersPresenter = createSelector(
  [getFolders],
  (folders): Array<FolderView> => {
    return folders.map(
      (item) =>
        new FolderView({
          id: item.id,
          name: item.name,
        }),
    );
  },
);
